/**
 * HTTP method override Interceptor.
 */

module.exports = {

    request: function (request) {

        if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
            request.headers['X-HTTP-Method-Override'] = request.method;
            request.method = 'POST';
        }

        return request;
    }

};



/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-resource/src/http/method.js
 ** module id = 96
 ** module chunks = 0
 **/